import runtime from 'regenerator-runtime';

const fetchArticles = async inputField => {

    const apiURL = `https://${location.hostname}/wp-json/wp/v2/posts?search=${inputField.value}&per_page=4&_embed=1`;
    const response = await fetch(apiURL);
    return await response.json();
};

const resultsHTML = dataArray => {
    let articleHTML = '';

    for (const article of dataArray) {

        const title = article.title.rendered;
        const link = article.link;

        articleHTML += `
                        <li class="article">
                            <div class="article__link">
                                <a href="${link}">
                                    ${title}
                                </a>
                            </div>
                        </li>
                    `;
    }

    return `<ul>${articleHTML}</ul>`;
};


const handleRequest = async elementData => {

    let {searchInput, searchWrapper,  loadingIndicator, resultsContainer} = elementData;

    resultsContainer.innerHTML = '';

    if (searchInput.value.length === 0) {

        loadingIndicator.style.display = 'none';
        searchWrapper.classList.remove('header__search--active');
        resultsContainer.classList.remove('header__search-suggestions--show');

        return;
    }

    searchWrapper.classList.add('header__search--active');
    resultsContainer.classList.add('header__search-suggestions--show');

    loadingIndicator.style.display = 'block';

    const articlesList = await fetchArticles(searchInput);

    console.log(articlesList)

    loadingIndicator.style.display = 'none';

    resultsContainer.innerHTML = resultsHTML(articlesList);
};

const handleSuggestions = elementData => {

    const {searchInput} = elementData;

    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    if ( viewportWidth <= 1080 ) {
        return;
    }

    searchInput.addEventListener('input', () => handleRequest(elementData));
};

const search = () => {

    const searchTrigger = document.querySelector('.header__search-open-trigger');
    const searchWrapper = document.querySelector('.header__search');
    const searchInput = document.querySelector('.header__search-field');
    const resultsContainer = document.querySelector('.header__search-suggestions');
    const loadingIndicator = document.querySelector('.header__search-loading');
    const overlay = document.querySelector('.overlay');
    const navigation = document.querySelector('.header__navigation');
    const joinCTA = document.querySelector('.header__join');

    const elementData = {searchTrigger, searchInput, searchWrapper, resultsContainer, loadingIndicator,overlay, navigation, joinCTA };

    searchTrigger.addEventListener('click', () => {

        searchWrapper.classList.toggle('header__search--open');
        overlay.classList.toggle('overlay--open');
        navigation.classList.toggle('hide');
        joinCTA.classList.toggle('hide');
    });

    overlay.addEventListener('click', () => {
        searchWrapper.classList.toggle('header__search--open');
        overlay.classList.toggle('overlay--open');
        navigation.classList.toggle('hide');
        joinCTA.classList.toggle('hide');
    });

    handleSuggestions(elementData);

}

export default search;